import type { AxiosInstance } from "axios";

export const ConcurrencyManager = (axios: AxiosInstance, MAX_CONCURRENT = 10) => {
    if (MAX_CONCURRENT < 1)
      throw "Concurrency Manager Error: minimun concurrent requests is 1";
    let instance = {
      queue: [] as any[],
      running: [],
      shiftInitial: () => {
        setTimeout(() => {
          if (instance.running.length < MAX_CONCURRENT) {
            instance.shift();
          }
        }, 0);
      },
      push: (reqHandler: any) => {
        instance.queue.push(reqHandler);
        instance.shiftInitial();
      },
      shift: () => {
        if (instance.queue.length) {
          const queued = instance.queue.shift();
          queued.resolver(queued.request);
          instance.running.push(queued as never);
        }
      },
      // Use as interceptor. Queue outgoing requests
      requestHandler: (req: any) => {
        return new Promise(resolve => {
          instance.push({ request: req, resolver: resolve });
        });
      },
      // Use as interceptor. Execute queued request upon receiving a response
      responseHandler: (res: any) => {
        instance.running.shift();
        instance.shift();
        return res;
      },
      responseErrorHandler: (res: any) => {
        return Promise.reject(instance.responseHandler(res));
      },
      interceptors: {
        request: null,
        response: null
      },
      detach: () => {
        axios.interceptors.request.eject(instance.interceptors.request as any);
        axios.interceptors.response.eject(instance.interceptors.response as any);
      }
    };
    // queue concurrent requests
    instance.interceptors.request = axios.interceptors.request.use(
      instance.requestHandler
    ) as any;
    instance.interceptors.response = axios.interceptors.response.use(
      instance.responseHandler,
      instance.responseErrorHandler,
    ) as any;
    return instance;
  };